import { render } from "./SkinProfileRow.vue?vue&type=template&id=4e3eb45e&scoped=true&bindings={}"
import script from "./SkinProfileRow.vue?vue&type=script&lang=ts"
export * from "./SkinProfileRow.vue?vue&type=script&lang=ts"

import "./SkinProfileRow.vue?vue&type=style&index=0&id=4e3eb45e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e3eb45e"

export default script